import React from 'react'
import SelectListDropdown from '../../common/select_list_dropdown/main';

export default class VideoDownloadOptions extends React.Component {
  state = {
    videoTypes: ['mp4', 'ogv', 'mov', 'flv', 'webm', 'animated gif', 'png', 'mp3/audio', 'waveform png'],
    videoFormats: ['original'],
    videoType: this.videoType,
    videoFormat: 'original',
    downloading: false
  };

  componentWillMount() {
    let height = this.props.attachment.height

    if (height >= 1080) {
      this.setState({videoFormats: ['480p', '720p', '1080p', 'original']})
    } else if (height >= 720) {
      this.setState({videoFormats: ['480p', '720p', 'original']})
    } else if (height >= 480) {
      this.setState({videoFormats: ['480p', 'original']})
    } else {
      this.setState({videoFormats: ['original']})
    }
  }

  get videoType() {
    return this.props.attachment.mimetype.split('/')[1];
  }

  openAdvancedOptionsModal() {
      let { attachment } = this.props;
      let url = `${this.props.brandfolder_slug}/attachments/display/${attachment.attachment_key}`;
      BF.dialog.render(encodeURIComponent(attachment.filename), url);
    }

  getFileValue(value) {
    this.setState({ videoType: value });
  }

  getFormatValue(value) {
    this.setState({ videoFormat: value });
  }

  downloadUrl() {
    let url;
    let cloudinaryUrl = this.props.attachment.url.replace('upload/', 'upload/fl_attachment/');
    let noFileExtension = cloudinaryUrl.substr(0, cloudinaryUrl.lastIndexOf('.'));
    if (this.state.videoType === 'animated gif') {
      let gifFlags = noFileExtension.replace('upload/', 'upload/vs_10,dl_500,fl_awebp,fl_animated/')
      url = `${gifFlags}.gif`;
    } else {
      url = `${noFileExtension}.${this.state.videoType}`
    }

    // Google Analytics
    BF.fx.dataLayerPush({"brandfolder": this.props.brandfolder_slug,
                         "event": "AdvancedVideoSimpleDownload"});

    if (this.state.videoFormat === 'original') {
      return url
    } else {
      let height = parseInt(this.state.videoFormat.substring(0, this.state.videoFormat.length -1));
      return url.replace('upload/', `upload/h_${height}/`)
    }
  }

  createAndShowDownloadUrl(e) {
    e.preventDefault();
    e.stopPropagation();
    let convertedUrl = this.downloadUrl();
    this.setState({ downloadUrl: convertedUrl }, function() {
      convertedUrl = this.state.downloadUrl;
      this.setState({ downloadUrl: convertedUrl }, function() {
        this.setState({ downloading: true }, function() {
          this.clickDownload();
        });
      });
    });
  }

  clickDownload() {
    document.getElementById("download-url").click();
    Notify.create({ title: "File Downloading", type: "success" });
    setTimeout(
      function() {
        let showLink = $("#" + this.props.asset_key + " .j-asset-name a");
        this.setState({ downloading: false });
        showLink.click();
        // Analytics
        Insight.createEvent("downloaded", this.props.asset_key, "asset");
      }.bind(this),
      1000
    );
  }

  render() {
    return (
      <div className='advanced-video-download-component'>
        <form className="m-download-custom-video">
          <SelectListDropdown
            list={this.state.videoTypes}
            defaultValue={this.videoType}
            dropdownLabel="FILE TYPE"
            onSelect={this.getFileValue.bind(this)}
            scroll={false}/>
          <SelectListDropdown
            list={this.state.videoFormats}
            defaultValue="original"
            dropdownLabel="RESOLUTION"
            onSelect={this.getFormatValue.bind(this)}
            scroll={false}/>
          <div className="s-download-attachment full">
            <div className="advanced-link half" style={{marginTop: '20px'}}>
              <a href="#" onClick={this.openAdvancedOptionsModal.bind(this)}> Advanced Options </a>
            </div>
            {this.state.downloading ? (
              <a
                id="download-url"
                href={this.state.downloadUrl}
                download={this.props.attachment.filename}
                />
            ) : ""}
            <button onClick={this.createAndShowDownloadUrl.bind(this)}
                    className="yacht-button half btn btn-default half"
                    style={{
                      padding: '10px 18px',
                      marginTop: '10px',
                      marginLeft: '-6px'}}>
                    Download
            </button>
          </div>
        </form>
      </div>
    );
  }
}
